<div *ngIf="breadcrumbList && breadcrumbList.length > 0"
     class="grid-toolbar-buttons-group-container w-p-100 gap-10px flex flex-row justify-between items-center">
  <particle-breadcrumbs
    (dropDownSelectionChanged)="navigateFromBreadCrumb($event)"
    (selectionChanged)="navigateFromBreadCrumb($event)"
    [breadcrumbs]="breadcrumbList ? breadcrumbList : null"
    [disableNavigation]="true"
    [class.navigation-locked]="locked"
  >
  </particle-breadcrumbs>
  <div class="toggle-buttons-view m-l-10 flex flex-col justify-center items-start">
    <!-- <label *ngIf="item.groupHeader" class="component-label">{{item.groupHeader}}</label>-->
    <mat-button-toggle-group #group="matButtonToggleGroup" class="view-change-toggle-container" [value]="viewType">
      <mat-button-toggle data-cy="btn-icon-view" value="IconView" (click)="toggleViewType('IconView')">
        <i class="far fa-border-all"></i>
      </mat-button-toggle>
      <mat-button-toggle data-cy="btn-list-view" value="ListView" (click)="toggleViewType('ListView')">
        <i class="far fa-list-ul"></i>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div *ngIf="showActions" class="grid-toolbar-buttons-group-container">
    <button data-cy="btn-actions" [matMenuTriggerFor]="menu" class="toolbar-action-btn" mat-button>Actions
      <i class="fal fa-angle-down"></i></button>
    <mat-menu #menu="matMenu" class="activity-menu left m-t-10">
      <button data-cy="btn-create-folder" (click)="onButtonClicked('create-folder')" mat-menu-item [disabled]="locked">Create Folder</button>
      <div class="toolbar-separator"></div>
      <button data-cy="btn-upload-file" (click)="onButtonClicked('upload-file')" mat-menu-item>Upload File</button>
      <ng-container *ngIf="deleteOption">
        <div class="toolbar-separator"></div>
        <button data-cy="btn-delete-file" (click)="onButtonClicked('delete-file')" mat-menu-item
                [disabled]="!selectedItems || selectedItems.length === 0">Delete</button>
      </ng-container>
    </mat-menu>
  </div>
</div>


<div class="p-t-15 icon-view-container" *ngIf="viewType === 'IconView'">
  <app-icon-view
    (parentChanged)="onIconViewItemClicked($event)"
    (selectedItemEvent)="onSelectedItems($event)"
    (iconViewItemDataFetched)="onIconViewDataFetched($event)"
    *ngIf="!hasDnDEnabled"
    [fileExtensionTypes]="fileExtensionTypes"
    [foldersSelectable]="foldersSelectable"
    [hideFiles]="hideFiles"
    [isClientDrive]=true
    [isDialogView]=true
    [queryName]="fileIconViewQueryName"
    [navigateInvalidateSubject]="invalidateSubject"
    [parentId]="parentId"
    [selectedList]="selectedItems"
    [showSelectedItem]=true
    [isFileSelector]=true
  >
  </app-icon-view>
  <app-icon-view
    (fileDropped)="onFileDropped($event)"
    (parentChanged)="onIconViewItemClicked($event)"
    (selectedItemEvent)="onSelectedItems($event)"
    *ngIf="hasDnDEnabled"
    [fileExtensionTypes]="fileExtensionTypes"
    [foldersSelectable]="foldersSelectable"
    [hideFiles]="hideFiles"
    [isClientDrive]=true
    [isDialogView]=true
    [queryName]="fileIconViewQueryName"
    [navigateInvalidateSubject]="invalidateSubject"
    [parentId]="parentId"
    [selectedList]="selectedItems"
    [showSelectedItem]=true
    appDnd
    [hasDragAndDrop]="true">
  </app-icon-view>
</div>

<div class="grid-container" *ngIf="viewType === 'ListView'">
  <div class="keno-grid-container" *ngIf="gridVisible">
    <particle-virtual-grid [sourceKey]="sourceType"
                           (valueChanged)="onCellEditorClicked($event)"
                           [isSelectableOnValueChange]="true"
                           sortFieldKey="CreateDate"
                           sortDirection="asc"
                           prefixSortFieldKey="FieldValues."
                           [sortEnabled]="true"
                           [invalidateSubject]="invalidateSubject"
                           api="FileStoreApi"
                           [serviceName]="dynamicItemService"
                           [parameters]="{'ParentId': parentId, 'IsFolderOnly': hideFiles, 'FileExtensionTypes': fileExtensionTypes}">
    </particle-virtual-grid>
  </div>


</div>

